enum FooterEnum {
  'footer.first_receive_news' = 'footer.first_receive_news',
  'footer.first_receive_news_subtitle' = 'footer.first_receive_news_subtitle',
  'product' = 'product',
  'footer.about' = 'footer.about',
  'footer.international_whiskey' = 'footer.international_whiskey',
  'footer.imprint' = 'footer.imprint',
  'footer.terms' = 'footer.terms',
  'footer.data_privacy' = 'footer.data_privacy',
  'footer.investors' = 'footer.investors',
  'footer.press' = 'footer.press',
  'footer.all_rights_reserved' = 'footer.all_rights_reserved',
  'footer.spiritory_newsletter' = 'footer.spiritory_newsletter',
  'footer.sign_up_for_our_newsletter_leave_your_email' = 'footer.sign_up_for_our_newsletter_leave_your_email',
  'footer.enter_your_email' = 'footer.enter_your_email',
  'footer.subscribe' = 'footer.subscribe',
  'footer.buy_on_spiritory' = 'footer.buy_on_spiritory',
  'footer.how_it_works' = 'footer.how_it_works',
  'footer.buyer_guide' = 'footer.buyer_guide',
  'footer.authentication' = 'footer.authentication',
  'footer.portfolio_guide' = 'footer.portfolio_guide',
  'footer.bottle_condition' = 'footer.bottle_condition',
  'footer.sell_on_spiritory' = 'footer.sell_on_spiritory',
  'footer.become_a_seller' = 'footer.become_a_seller',
  'footer.seller_guide' = 'footer.seller_guide',
  'footer.shipping_guide' = 'footer.shipping_guide',
  'footer.products' = 'footer.products',
  'footer.all' = 'footer.all',
  'footer.top_brands' = 'footer.top_brands',
  'footer.new' = 'footer.new',
  'footer.countries' = 'footer.countries',
  'footer.collections' = 'footer.collections',
  'footer.limited_edition' = 'footer.limited_edition',
  'footer.old_and_rare' = 'footer.old_and_rare',
  'footer.other_spirits' = 'footer.other_spirits',
  'footer.all_brands' = 'footer.all_brands',
  'footer.scotch_whisky' = 'footer.scotch_whisky',
  'spiritory_magazine' = 'spiritory_magazine',
  'footer.help' = 'footer.help',
  'footer.help_center' = 'footer.help_center',
  'footer.contact_us' = 'footer.contact_us',
  'footer.faqs' = 'footer.faqs',
  'footer.payment_methods' = 'footer.payment_methods',
  'footer.language' = 'footer.language',
  'footer.spiritory_magazine' = 'footer.spiritory_magazine',
  'footer.download_on' = 'footer.download_on',
  'footer.loading_subscribing_to_newsletter' = 'footer.loading_subscribing_to_newsletter',
  'footer.error_subscribing_to_the_newsletter' = 'footer.error_subscribing_to_the_newsletter',
  'footer.succesfully_subscribed' = 'footer.succesfully_subscribed',
  'footer.do_you_want_to_be_the_first_to_receive_the_news' = 'footer.do_you_want_to_be_the_first_to_receive_the_news',
  'footer.spiritory_apps' = 'footer.spiritory_apps',
  'footer.about_us' = 'footer.about_us',
  'footer.company' = 'footer.company',
  'footer.magazine' = 'footer.magazine',
  'footer.cookies' = 'footer.cookies',
  'footer.world_whisky' = 'footer.world_whisky',
  'footer.japanese_whisky' = 'footer.japanese_whisky',
  'footer.irish_whisky' = 'footer.irish_whisky',
  'footer.canadian_whisky' = 'footer.canadian_whisky',
  'footer.american_whisky' = 'footer.american_whisky',
  'footer.indian_whisky' = 'footer.indian_whisky',
  'footer.german_whisky' = 'footer.german_whisky',
  'footer.top_whisky_brands' = 'footer.top_whisky_brands',
  'footer.top_scotch_whisky_brands' = 'footer.top_scotch_whisky_brands',
  'footer.highland_park_scotch' = 'footer.highland_park_scotch',
  'footer.laphroaig_scotch' = 'footer.laphroaig_scotch',
  'footer.glenfiddich_scotch' = 'footer.glenfiddich_scotch',
  'footer.lagavulin_scotch' = 'footer.lagavulin_scotch',
  'footer.ardbeg_scotch' = 'footer.ardbeg_scotch',
  'footer.glenmorangie_scotch' = 'footer.glenmorangie_scotch',
  'footer.support' = 'footer.support',
  'footer.buyer_protection' = 'footer.buyer_protection',
  'footer.authentication_process' = 'footer.authentication_process',
  'footer.buy_popular_whisky' = 'footer.buy_popular_whisky',
  'footer.sell_your_whisky' = 'footer.sell_your_whisky',
}

export { FooterEnum };